/** Values for CMS list filters (`status.equals`, dropdown labels). */
export const CARD_REPLACEMENT_STATUS_FILTER_OPTIONS = [
    'REQUESTED',
    'PENDING',
    'SUBMITTED',
    'APPROVED',
    'REJECTED',
    'COMPLETED',
    'CANCELLED',
].map(v => ({ name: v, value: v }));
